import React from "react";
import { Crown } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { tierStyle } from "@/lib/loyalty";

export const TierBadge = ({ tier, size = "md", showLabel = true }) => {
  const { lang } = useLanguage();
  if (!tier) return null;
  const st = tierStyle(tier.key);
  const name = lang === "ar" ? tier.name_ar : tier.name_en;
  const pad = size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-3 py-1 text-xs";
  const icon = size === "sm" ? 11 : 13;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border font-medium ${pad}`}
      style={{ color: st.color, backgroundColor: st.bg, borderColor: st.border }}
      data-testid={`tier-badge-${tier.key}`}
    >
      <Crown size={icon} />
      {showLabel && name}
    </span>
  );
};
